export const MINIMUM_QUERY_LENGTH = 3;



// WEBPACK FOOTER //
// ./src/components/dashboard/search/enums/searchBoxSettings.js